import { C } from './Element';
import { isDebug } from './Basics';

export const Analytics = {
  isEnabled: false,
  isGA: false,
  isGTM: false,
  code: null,

  init: function () {
    if (this.isEnabled) return;

    this.isEnabled = true;

    C.forEach("[data-cookiecategory='analytics']", (item) => {
      if (item.getAttribute("data-src")) {
        item.setAttribute("src", item.getAttribute("data-src"));
        item.removeAttribute("data-src");
      } else {
        item.setAttribute("type", "text/javascript");

        this.isGTM = item.text.indexOf("gtm") > -1;
        this.isGA = item.text.indexOf("ga") > -1;
        this.isGTAG = item.text.indexOf("gtag") > -1;
        this.code = item.getAttribute("data-code");

        C.remove(item);
        document.head.appendChild(item);
      }
    });
  },

  clear: function () {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied',
        ad_storage: 'denied'
      });
    }

    if (this.code) {
      window['ga-disable-' + this.code] = true;
    }

    const analyticsCookieMatchers = [
      /^_ga$/,
      /^_ga_/,
      /^_gid$/,
      /^_gat$/,
      /^_gat_/,
      /^_gcl_/,
      /^_dc_gtm_/,
      /^AMP_TOKEN$/,
    ];

    const cookies = document.cookie ? document.cookie.split(';') : [];
    const hostname = window.location.hostname;
    const hostParts = hostname.split('.').filter(Boolean);
    const domains = new Set(['', hostname, '.' + hostname]);

    for (let i = 0; i < hostParts.length - 1; i++) {
      const parent = hostParts.slice(i).join('.');
      domains.add(parent);
      domains.add('.' + parent);
    }

    const expire = 'expires=Thu, 01 Jan 1970 00:00:01 GMT';
    const extras = ['', ' Secure;', ' SameSite=Lax;', ' SameSite=None; Secure;'];

    cookies.forEach(cookie => {
      const [rawName] = cookie.split('=');
      const name = rawName.trim();
      const isAnalyticsCookie = analyticsCookieMatchers.some(regex => regex.test(name));

      if (!isAnalyticsCookie) return;

      domains.forEach(domain => {
        extras.forEach(extra => {
          const domainPart = domain ? `domain=${domain};` : '';
          document.cookie = `${name}=; ${expire}; path=/; ${domainPart} ${extra}`;
        });
      });
    });

    this.isEnabled = false;
    this.isGA = false;
    this.isGTM = false;
    this.isGTAG = false;
    this.code = null;
  },

  sendUrl: function (__url, __title) {
    if (this.isGA) {
      ga('set', { page: __url, title: __title });
      ga('send', 'pageview');

      if (isDebug) {
        console.log('send', 'pageview', __url, __title);
      }
    }

    if (this.isGTAG) {
      gtag('config', this.code, { 'page_path': __url });

      if (isDebug) {
        console.log('config', this.code, __url, __title);
      }
    }

    if (this.isGTM && window && window.dataLayer !== undefined) {
      window.dataLayer.push({
        'event': 'Pageview',
        'pagePath': __url,
        'pageTitle': __title
      });

      if (isDebug) console.log('push', 'pageview', __url, __title);
    }
  },

  sendEvent: function (__data) {
    if (this.isGTAG) {
      gtag('event', __data, {
        'event_callback': function () {
          if (isDebug) {
            console.log('event', __data);
          }
        }
      });
    }

    if (this.isGA) {
      const data = __data.split(",");
      ga('send', 'event', data[0] ? data[0] : '', data[1] ? data[1] : '', data[2] ? data[2] : 1);

      if (isDebug) {
        console.log('send', 'event', data[0] ? data[0] : '', data[1] ? data[1] : '', data[2] ? data[2] : 1);
      }
    }

    if (this.isGTM) {
      let data = __data;

      if (typeof data != 'object') data = JSON.parse(__data.split("'").join('"'));

      if (isDebug) console.log('send GTM', data);
      else if (window && window.dataLayer !== undefined) {
        window.dataLayer.push(data);
      }
    }
  }
};
